import Logo from "./ui/Logo";
import Button from "./ui/Button";

import { getDateFormat, getIsUsa } from "./util/settings";
import { getLanguageFlag, LOCALE_DESC_MAP } from "./util/localisation";

import "./Welcome.css";

const Welcome = ({ onContinueClick, onSettingsClick }) => {
  const dateFormat = getDateFormat();

  const localeCode = dateFormat;

  return (
    <div className="Welcome">
      <div className="-inner">
        <Logo />
        <p>
          Welcome to <b>Weekle</b>, a web app to teach you how to quickly
          determine the day of the week from any date.
        </p>
        <p>
          There are three stages for your journey, first to <b>learn</b>, then
          to <b>{getIsUsa() ? "practice" : "practise"}</b>, and finally a daily
          12-question <b>game</b> to reinforce the skill.
        </p>
        <p>
          Language and date format is set to:{" "}
          <em>
            {getLanguageFlag(localeCode)} {LOCALE_DESC_MAP[localeCode]}
          </em>{" "}
          <Button small onClick={onSettingsClick}>
            Change
          </Button>
          <br />
          <i>(more than 60 languages available)</i>
        </p>
        <footer>
          <Button primary large onClick={onContinueClick}>
            Continue
          </Button>
        </footer>
      </div>
    </div>
  );
};

export default Welcome;
